import {RootState, rootState} from '@lib/store/rootState';
import {createSelector} from '@lib/store/utils';
import {
  FirstViewScrollStatus,
  MediaQueryScreenMode,
  Orientation,
  PageIndicatorStatus,
} from '@services/types';

export interface AppState {
  currentPageUrl: string;
  isOpenGlobalNav: boolean;
  pageIndicatorStatus: PageIndicatorStatus;
  mediaQueryScreenMode: MediaQueryScreenMode | undefined;
  orientation: Orientation | undefined;
  firstViewScrollStatus: FirstViewScrollStatus | undefined;
  programTag: string;
  newsUrl: string;
}

export const initialAppState: AppState = {
  currentPageUrl: location.href,
  firstViewScrollStatus: undefined,
  isOpenGlobalNav: false,
  mediaQueryScreenMode: undefined,
  orientation: undefined,
  pageIndicatorStatus: 'show',
  programTag: '',
  newsUrl: '',
};

export const selectAppState = (state: RootState) => {
  return state.app;
};

const selectCurrentPageUrl = createSelector(
  selectAppState,
  ({currentPageUrl}) => currentPageUrl,
);

const selectPageIndicatorStatus = createSelector(
  selectAppState,
  ({pageIndicatorStatus}) => pageIndicatorStatus,
);

const selectMediaQueryScreenMode = createSelector(
  selectAppState,
  ({mediaQueryScreenMode}) => mediaQueryScreenMode,
);

const selectOrientation = createSelector(
  selectAppState,
  ({orientation}) => orientation,
);

const selectFirstViewStatus = createSelector(
  selectAppState,
  ({firstViewScrollStatus}) => firstViewScrollStatus,
);

const selectIsOpenGlobalNav = createSelector(
  selectAppState,
  ({isOpenGlobalNav}) => isOpenGlobalNav,
);

const selectProgramTag = createSelector(
  selectAppState,
  ({programTag}) => programTag,
);

const selectNewsUrl = createSelector(selectAppState, ({newsUrl}) => newsUrl);

const appReducers = {
  currentPageUrlSaved: (payload: string) => {
    rootState.app.programTag = '';
    rootState.app.currentPageUrl = payload;
  },
  firstViewScrollStatusSaved: (payload: FirstViewScrollStatus) => {
    rootState.app.firstViewScrollStatus = payload;
  },
  isOpenGlobalNavSaved: (payload: boolean) => {
    rootState.app.isOpenGlobalNav = payload;
  },
  mediaQueryScreenModeSaved: (payload: MediaQueryScreenMode) => {
    rootState.app.mediaQueryScreenMode = payload;
  },
  newsUrlSaved: (payload: string) => {
    rootState.app.newsUrl = payload;
  },
  orientationSaved: (payload: Orientation) => {
    rootState.app.orientation = payload;
  },
  pageIndicatorStatusSaved: (payload: PageIndicatorStatus) => {
    rootState.app.pageIndicatorStatus = payload;
  },
  programTagSaved: (payload: string) => {
    rootState.app.programTag = payload;
  },
};

export const appSelectors = {
  selectCurrentPageUrl,
  selectFirstViewStatus,
  selectIsOpenGlobalNav,
  selectMediaQueryScreenMode,
  selectNewsUrl,
  selectOrientation,
  selectPageIndicatorStatus,
  selectProgramTag,
};

export const {
  currentPageUrlSaved,
  firstViewScrollStatusSaved,
  mediaQueryScreenModeSaved,
  pageIndicatorStatusSaved,
  orientationSaved,
  isOpenGlobalNavSaved,
  programTagSaved,
  newsUrlSaved,
} = appReducers;
